import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import assetsPath from '../../index.js';

/**
 * Use cdn for assets, this needs custom webpack loader with angular imports.
 *
 * Image used from CDN in CSS : https://cdn.nordnet.fr/images/logo-orange.png
 *
 */
/**
 * The Footer molecule contains the brand logo and links to others pages.
 * Under 767px wide, most links are not shown.
 *
 * @prop baseUrl The base Url. Used to build others Url in component.
 * @prop assistanceUrl The assistance website specific Url.
 * @prop acceoUrl The Acceo service specific Url.
 * @prop didomiUrl The Didomi script to launch Cookies modal.
 * @cssprop --icon-inline-font-size overrides font-size of icon-inline text.
 */
@customElement('nn-footer')
export class Footer extends LitElement {
  static styles = css`
    /* NEW FOOTER by SM 2023/07/17 */
    .hidden,
    .show-off {
      display: none;
    }
    .custom-flex {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .icon-inline {
      align-items: center;
      background: none;
      border: 0;
      color: var(--black, #000);
      display: flex;
      border-radius: 0;
      box-shadow: none;
      font-family: 'font-medium';
      font-size: 0.875em;
      justify-content: left;
      line-height: 1;
      margin: 0;
      padding: 0 0 5px;
      text-align: left;
      text-decoration: none;
      text-transform: none;
      vertical-align: inherit;
      width: 100%;
    }
    .icon-inline--image {
      flex-shrink: 0;
    }
    .icon-inline--text {
      padding: 0 0 0 8px;
    }
    .icon-inline--text_title {
      font-family: 'font-heavy';
      padding: 0 0 3px 0;
    }
    .icon-inline--text_text {
      color: var(--black-80, #595959);
      font-family: 'font-light';
      font-size: 0.929em;
    }
    .icon-inline.multiple {
      align-items: start;
    }
    /* GENERIC SINGLE TOGGLE */

    .single-toggle-label {
      display: inline-block;
      max-width: 100%;
      position: relative;
    }
    .single-toggle-input {
      display: none;
    }
    .single-toggle-input:checked + .single-toggle-label:after {
      transform: rotate(135deg);
    }
    .single-toggle-input ~ .single-toggle-content {
      display: none;
    }
    .single-toggle-input:checked ~ .single-toggle-content {
      display: block;
    }
    .single-toggle-label:after {
      border-left: 4px solid var(--nn-black-80, #595959);
      border-bottom: 4px solid var(--nn-black-80, #595959);
      content: '';
      display: inline-block;
      height: 15px;
      vertical-align: middle;
      width: 15px;
      transform: rotate(-45deg);
      position: absolute;
      right: 5px;
      top: 0;
    }
    #footer {
      background: var(--nn-black-98, #0e0e0e);
      font-family: 'font-light';
      font-size: 16px;
      margin: 0;
      padding: 0;
      border-top: 1px solid var(--nn-black-26, #d1d1d1);
    }
    #footer ul,
    #footer li {
      list-style-type: none;
    }
    .subtitle-02 {
      color: var(--black, #000);
      font-family: 'font-heavy';
      font-size: 20px;
      line-height: calc(2ex + 4px);
    }
    #footer * {
      box-sizing: border-box;
    }
    #footer .container {
      margin: 0 auto;
      max-width: 1470px;
      padding: 0 15px;
      width: 100%;
    }
    #footer a,
    #footer a:focus,
    #footer a:active,
    #footer a:visited,
    #footer a:hover {
      text-decoration: none;
    }
    #footer ul {
      margin: 0;
      padding: 0;
    }
    #footer ul li {
      margin: 0;
    }
    #footer .footer-top {
      background: var(--white, #fff);
    }
    #footer .footer-top .custom-flex {
      align-items: center;
      flex-wrap: nowrap;
      gap: 8px;
      justify-content: space-between;
      min-height: 128px;
      padding: 16px 0;
      width: 100%;
    }
    #footer .footer-top .icon-inline {
      font-size: 1em;
      padding: 0;
    }
    #footer .footer-top .icon-inline--text_title {
      color: var(--nn-black-nordnet, #001018);
      font-size: 0.75em;
      font-weight: 400;
      text-transform: uppercase;
    }
    #footer .footer-top .icon-inline--text_text {
      color: var(--nn-grey-54, #686868);
      font-family: 'font-extra-light', 'font-light';
      font-size: 0.75em;
      font-weight: 400;
    }
    #footer .footer-social {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 8px;
      margin: 0;
    }
    #footer .footer-social--title {
      font-family: 'font-heavy';
      color: var(--nn-grey-80, #323232);
      font-size: 0.75em;
      font-weight: 400;
      text-transform: uppercase;
    }
    #footer .footer-social--text {
      margin: 0;
    }
    #footer .footer-middle {
      padding: 44px 0 16px;
    }
    #footer .footer-middle--subtitle {
      font-family: 'font-light';
      display: inline-block;
      padding: 0 0 12px;
    }
    #footer .footer-middle a,
    #footer .footer-middle a:focus,
    #footer .footer-middle a:active,
    #footer .footer-middle a:visited,
    #footer .footer-middle a:hover {
      color: var(--nn-grey-114, #ececec);
      transition: var(--nn-transition, 0.3s);
    }
    #footer .footer-middle a:hover {
      color: var(--nn-white, #fff);
      text-decoration: underline;
    }
    #footer .footer-middle .single-toggle-label {
      font-family: 'font-medium';
      color: var(--nn-black-40, #929292);
      font-weight: 400;
      margin: 0 0 28px;
    }
    #footer
      .footer-middle
      .single-toggle-input:checked
      + .single-toggle-label:after {
      top: 10px;
    }
    #footer .footer-middle .custom-flex {
      align-items: stretch;
      text-align: left;
    }
    #footer .footer-middle .custom-flex--column {
      padding: 0 24px;
    }
    #footer .footer-middle .custom-flex--column:first-child {
      flex-basis: auto;
      flex-shrink: 0;
      padding-left: 0;
      width: 50%;
    }
    #footer .footer-middle .custom-flex--column:nth-child(2) {
      flex-basis: auto;
      flex-shrink: 0;
      width: calc((100% / 12) * 3);
    }
    #footer .footer-middle .custom-flex--column:last-child {
      flex-basis: auto;
      flex-shrink: 0;
      padding-right: 0;
      width: calc((100% / 12) * 3);
    }
    #footer .footer-middle .custom-flex--column.with-decoration {
      position: relative;
    }
    #footer .footer-middle .custom-flex--column.with-decoration:before,
    #footer .footer-middle .custom-flex--column.with-decoration:after {
      background: var(--nn-grey-3, #494949);
      content: '';
      display: block;
      height: 100%;
      width: 1px;
      position: absolute;
      left: 0;
      top: 0;
    }
    #footer .footer-middle .custom-flex--column.with-decoration:after {
      left: inherit;
      right: 0;
    }
    #footer
      .footer-middle
      .custom-flex--column.with-decoration
      .footer-middle--category {
      padding-bottom: 16px;
    }
    #footer .footer-middle .custom-flex.inner-flex .custom-flex--column,
    #footer
      .footer-middle
      .custom-flex.inner-flex
      .custom-flex--column:last-child {
      flex-basis: auto;
      flex-shrink: 0;
      width: 50%;
    }
    #footer .footer-middle--category.with-margin {
      padding-bottom: 32px;
    }
    #footer .footer-middle--category_item {
      padding: 0 0 12px;
    }
    #footer .footer-middle--category_item .anchor,
    #footer .footer-middle--category_item .anchor:active,
    #footer .footer-middle--category_item .anchor:focus,
    #footer .footer-middle--category_item .anchor:visited,
    #footer .footer-middle--category_item .anchor:hover {
      color: var(--nn-bleu-hyperlien, #3695ec);
    }
    #footer .footer-middle--category_item .anchor:hover {
      color: var(--nn-white, #fff);
    }
    #footer .footer-bottom {
      padding: 0 0 44px;
      width: 100%;
    }
    #footer .footer-bottom--listing {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      width: 100%;
    }
    #footer .footer-bottom a,
    #footer .footer-bottom a:active,
    #footer .footer-bottom a:focus,
    #footer .footer-bottom a:visited,
    #footer .footer-bottom a:hover {
      color: var(--nn-grey-114, #ececec);
      font-size: calc(16px * 0.875);
      transition: 0.3s;
    }
    #footer .footer-bottom a:hover {
      color: var(--white, #fff);
      text-decoration: underline;
    }
    #footer .footer-bottom--links {
      align-items: center;
      width: 100%;
    }
    #footer .footer-bottom--logos {
      justify-content: space-between;
      padding: 0 0 32px;
      position: relative;
    }
    #footer .footer-bottom--logos:after {
      background: var(--nn-grey-3, #494949);
      content: '';
      display: block;
      height: 1px;
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 16px;
    }
    @media (max-width: 1300px) {
      #footer .footer-top .custom-flex {
        gap: 24px 8px;
        height: auto;
        flex-wrap: wrap;
        justify-content: center;
        padding: 24px 0;
      }
      #footer .footer-top .custom-flex--column {
        flex-basis: auto;
        flex-shrink: 0;
        width: calc(33.33% - 6px);
      }
      #footer .footer-top .icon-inline {
        margin: 0 auto;
        width: fit-content;
      }
      #footer .footer-bottom--listing {
        gap: 16px 0;
      }
      #footer .footer-bottom--listing_item {
        max-width: 50%;
        text-align: center;
        width: inherit;
      }
    }
    @media (max-width: 991px) {
      #footer .footer-top .custom-flex--column {
        width: 38%;
      }
      #footer .footer-top .custom-flex--column:last-child {
        width: 100%;
      }
      #footer .footer-middle {
        padding-bottom: 32px;
      }
      #footer
        .footer-middle
        .custom-flex--parent
        > .custom-flex--column:first-child {
        padding-right: 0;
      }
      #footer .footer-middle .custom-flex--column:first-child {
        padding-bottom: 16px;
        width: 100%;
      }
      #footer .footer-middle .custom-flex--column:nth-child(2) {
        width: 50%;
      }
      #footer .footer-middle .custom-flex--column:last-child {
        width: 50%;
      }
      #footer .footer-middle .custom-flex--column.with-decoration {
        padding-left: 0;
      }
      #footer .footer-middle .custom-flex--column.with-decoration:before {
        display: none;
      }
    }
    @media (max-width: 991px) and (min-width: 800px) {
      #footer .footer-top .custom-flex {
        padding: 24px 72px;
      }
    }
    @media (min-width: 768px) {
      #footer .footer-middle .single-toggle-label:after {
        display: none;
      }
      #footer .footer-middle .single-toggle-content {
        display: block;
      }
    }
    @media (max-width: 991px) and (min-width: 768px) {
      #footer .footer-top .icon-inline {
        margin: 0;
      }
    }
    @media (max-width: 900px) and (min-width: 768px) {
      #footer .footer-top .custom-flex--column {
        width: 300px;
      }
    }
    @media (max-width: 799px) and (min-width: 768px) {
      #footer .footer-top .custom-flex {
        padding: 24px 32px;
      }
    }
    @media (max-width: 767px) {
      .subtitle-02 {
        font-size: calc((16px * 1.25) * 0.833);
      }
      #footer {
        border-top-width: 2px;
      }
      #footer .footer-top .custom-flex--column {
        width: calc(50% - 4px);
      }
      #footer .footer-social--title {
        flex-basis: auto;
        flex-shrink: 0;
        width: 100%;
        text-align: center;
      }
      #footer .footer-top .icon-inline {
        width: 282px;
      }
      #footer .footer-middle {
        padding: 24px 0 0;
      }
      #footer .footer-middle .paragraph-02 {
        font-size: 16px;
      }
      #footer .footer-middle .single-toggle-label {
        cursor: pointer;
        margin: 0 0 16px;
      }
      #footer .footer-middle .single-toggle-label:after {
        border-color: var(--nn-black-40, #929292);
        border-width: 0 0 2px 2px;
        height: 10px;
        width: 10px;
        right: -22px;
        top: 3px;
      }
      #footer .footer-middle .custom-flex--parent {
        padding-bottom: 16px;
        text-align: center;
      }
      #footer
        .footer-middle
        .custom-flex--parent
        > .custom-flex--column:first-child {
        padding-bottom: 0;
      }
      #footer .footer-middle .custom-flex--parent .footer-middle--subtitle {
        font-size: 16px;
      }
      #footer .footer-middle .custom-flex--column {
        padding-left: 0;
        padding-right: 0;
        text-align: center;
      }
      #footer .footer-middle .custom-flex--column:first-child {
        padding-bottom: 0;
      }
      #footer .footer-middle .custom-flex--column:nth-child(2) {
        width: 100%;
      }
      #footer .footer-middle .custom-flex--column:last-child {
        width: 100%;
      }
      #footer .footer-middle .custom-flex--column.with-decoration:after {
        display: none;
      }
      #footer .footer-middle .custom-flex.inner-flex .custom-flex--column,
      #footer
        .footer-middle
        .custom-flex.inner-flex
        .custom-flex--column:last-child {
        text-align: center;
        width: 100%;
      }
      #footer
        .footer-middle
        .custom-flex.inner-flex
        > .custom-flex--column:first-child
        .footer-middle--category_item {
        display: none;
      }
      #footer
        .footer-middle
        .custom-flex.inner-flex
        > .custom-flex--column:last-child {
        padding-bottom: 16px;
      }
      #footer .footer-middle--category.with-margin {
        padding-bottom: 0;
      }
      #footer
        .footer-middle--category.with-margin
        .footer-middle--category_item {
        display: none;
      }
      #footer
        .footer-middle--category.with-margin
        ~ .footer-middle--category
        .footer-middle--category_item {
        display: none;
      }
      #footer .footer-bottom {
        padding: 0 0 24px;
      }
      #footer .footer-bottom--listing {
        gap: 16px 0;
      }
      #footer .footer-bottom--listing_item {
        max-width: 100%;
      }
      #footer .footer-bottom a,
      #footer .footer-bottom a:active,
      #footer .footer-bottom a:focus,
      #footer .footer-bottom a:visited,
      #footer .footer-bottom a:hover {
        font-size: 16px;
      }
      #footer .footer-bottom--links {
        order: 1;
      }
      #footer .footer-bottom--logos {
        order: 2;
        padding: 32px 0 0;
      }
      #footer .footer-bottom--logos:after {
        display: none;
      }
      #footer .footer-bottom > .container {
        display: flex;
        flex-direction: column;
      }
    }
    @media (max-width: 600px) {
      #footer .footer-top .custom-flex--column {
        width: 100%;
      }
    }
    @media (max-width: 479px) {
      #footer .footer-bottom--logos {
        align-items: center;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 16px 32px;
      }
    }
  `;

  @property({ type: String }) baseUrl = 'https://www.nordnet.com';

  @property({ type: String }) assistanceUrl = 'https://assistance.nordnet.com';

  @property({ type: String }) acceoUrl = 'https://www.acce-o.fr/client/nordnet';

  @property({ type: String }) didomiUrl = '';
  // javascript:Didomi.preferences.show()

  render() {
    return html`
      <footer id="footer" class="footer">
        <div class="footer-top">
          <div class="container">
            <div class="custom-flex">
              <div class="custom-flex--column">
                <div class="link">
                  <div class="icon-inline">
                    <img
                      width="24"
                      height="24"
                      class="icon-inline--image"
                      src="${assetsPath}/icons/user-headset-black-24.svg"
                      alt="Besoin d’aide, d’info ? Appelez le 3420 (Service gratuit + prix appel)"
                      loading="lazy"
                      aria-hidden="true"
                    />
                    <div class="icon-inline--text">
                      <div class="icon-inline--text_title">
                        Besoin d’aide, d’info&nbsp;? Appelez le 3420
                      </div>
                      <div class="icon-inline--text_text">
                        Service gratuit +&nbsp;prix appel
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="custom-flex--column">
                <a
                  id="footer-contact-link"
                  class="link"
                  href="${this.baseUrl}/contactez-nous?reset=all"
                >
                  <div class="icon-inline">
                    <img
                      width="24"
                      height="24"
                      class="icon-inline--image"
                      src="${assetsPath}/icons/globe-web-black-24.svg"
                      alt="Contactez-nous directement en ligne"
                      loading="lazy"
                      aria-hidden="true"
                    />
                    <div class="icon-inline--text">
                      <div class="icon-inline--text_title">Contactez-nous</div>
                      <div class="icon-inline--text_text">
                        Directement en ligne
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div class="custom-flex--column">
                <a
                  id="footer-acceo-link"
                  class="link"
                  href="${this.acceoUrl}"
                  target="_blank"
                  rel="noopener"
                  title="Vous êtes sourd ou malentendant ? Contactez-nous avec ACCEO"
                >
                  <div class="icon-inline">
                    <img
                      width="24"
                      height="24"
                      class="icon-inline--image"
                      src="${assetsPath}/icons/ear-deaf-black-24.svg"
                      alt="Vous êtes sourd ou malentendant ? Contactez-nous avec ACCEO"
                      loading="lazy"
                      aria-hidden="true"
                    />
                    <div class="icon-inline--text">
                      <div class="icon-inline--text_title">
                        Sourd ou malentendant&nbsp;?
                      </div>
                      <div class="icon-inline--text_text">
                        Contactez-nous avec ACCEO
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div class="custom-flex--column">
                <a
                  id="footer-assistance-link"
                  class="link"
                  target="_blank"
                  rel="noopener"
                  href="${this.assistanceUrl}"
                  title="Assistance en ligne"
                >
                  <div class="icon-inline">
                    <img
                      width="24"
                      height="24"
                      class="icon-inline--image"
                      src="${assetsPath}/icons/life-ring-black-24.svg"
                      alt="Assistance - Aide en ligne pour une utilisation optimale"
                      loading="lazy"
                      aria-hidden="true"
                    />
                    <div class="icon-inline--text">
                      <div class="icon-inline--text_title">Assistance</div>
                      <div class="icon-inline--text_text">
                        Aide en ligne pour une utilisation optimale
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div class="custom-flex--column">
                <dl class="footer-social">
                  <dt class="footer-social--title">Continuons la discussion</dt>
                  <dd class="footer-social--text">
                    <a
                      id="footer-youtube"
                      class="footer-social--link"
                      title="Nordnet sur Youtube"
                      href="https://www.youtube.com/c/nordnet"
                      target="_blank"
                      rel="noopener nofollow"
                    >
                      <img
                        width="24"
                        height="24"
                        src="${assetsPath}/icons/social-youtube-red-24.svg"
                        alt="Youtube"
                        aria-hidden="true"
                        loading="lazy"
                      />
                      <span class="hidden">Nordnet sur Youtube</span>
                    </a>
                  </dd>
                  <dd class="footer-social--text">
                    <a
                      id="footer-twitter"
                      class="footer-social--link"
                      title="Nordnet sur X"
                      href="https://x.com/NordnetOFFICIEL"
                      target="_blank"
                      rel="noopener nofollow"
                    >
                      <img
                        width="24"
                        height="24"
                        src="${assetsPath}/icons/social-twitter-blue-24.svg"
                        alt="X"
                        aria-hidden="true"
                        loading="lazy"
                      />
                      <span class="hidden">Nordnet sur X</span>
                    </a>
                  </dd>
                  <dd class="footer-social--text">
                    <a
                      id="footer-facebook"
                      class="footer-social--link"
                      title="Nordnet sur Facebook"
                      href="https://www.facebook.com/NordnetOFFICIEL"
                      target="_blank"
                      rel="noopener nofollow"
                    >
                      <img
                        width="24"
                        height="24"
                        src="${assetsPath}/icons/social-facebook-blue-24.svg"
                        alt="Facebook"
                        aria-hidden="true"
                        loading="lazy"
                      />
                      <span class="hidden">Nordnet sur Facebook</span>
                    </a>
                  </dd>
                  <dd class="footer-social--text">
                    <a
                      id="footer-linkedin"
                      class="footer-social--link"
                      title="Nordnet sur LinkedIn"
                      href="https://www.linkedin.com/company/nordnet-officiel/mycompany/"
                      target="_blank"
                      rel="noopener nofollow"
                    >
                      <img
                        width="24"
                        height="24"
                        src="${assetsPath}/icons/social-linkedin-blue-24.svg"
                        alt="LinkedIn"
                        aria-hidden="true"
                        loading="lazy"
                      />
                      <span class="hidden">Nordnet sur linkedIn</span>
                    </a>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-middle">
          <div class="container">
            <div class="custom-flex custom-flex--parent">
              <div class="custom-flex--column">
                <input
                  class="single-toggle-input"
                  type="checkbox"
                  name="singletab"
                  id="footer-tab-1"
                />
                <label
                  class="single-toggle-label subtitle-02"
                  for="footer-tab-1"
                  >Nos Offres</label
                >
                <div class="single-toggle-content">
                  <div class="custom-flex inner-flex">
                    <div class="custom-flex--column">
                      <a
                        id="footer-internet-gamme"
                        class="footer-middle--subtitle subtitle-02"
                        title="Découvrez notre gamme Accès Internet"
                        href="${this.baseUrl}/connexion-internet"
                      >
                        Accès Internet
                      </a>
                      <ul class="footer-middle--category with-margin">
                        <li class="footer-middle--category_item">
                          <a
                            class="paragraph-02"
                            id="footer-satellite"
                            title="Internet Satellite neosat"
                            href="${this
                              .baseUrl}/connexion-internet/internet-satellite"
                          >
                            Internet Satellite neosat
                          </a>
                        </li>
                        <li class="footer-middle--category_item">
                          <a
                            class="paragraph-02"
                            id="footer-satellite-pro"
                            title="Internet Satellite neosat pro plus"
                            href="${this
                              .baseUrl}/connexion-internet/internet-satellite-pro"
                          >
                            Internet Satellite neosat pro +
                          </a>
                        </li>
                        <li class="footer-middle--category_item">
                          <a
                            class="paragraph-02"
                            id="footer-fibre"
                            title="Internet Fibre"
                            href="${this
                              .baseUrl}/connexion-internet/internet-fibre"
                          >
                            Internet Fibre
                          </a>
                        </li>
                        <li class="footer-middle--category_item">
                          <a
                            class="paragraph-02"
                            id="footer-adsl"
                            title="Internet ADSL"
                            href="${this
                              .baseUrl}/connexion-internet/internet-adsl"
                          >
                            Internet ADSL
                          </a>
                        </li>
                        <li class="footer-middle--category_item">
                          <a
                            class="paragraph-02"
                            id="footer-4gfix"
                            title="Internet 4GFIX"
                            href="${this
                              .baseUrl}/connexion-internet/internet-4g"
                          >
                            Internet 4GFIX
                          </a>
                        </li>
                        <li class="footer-middle--category_item">
                          <a
                            class="paragraph-02"
                            id="footer-radio"
                            title="Internet Radio MISTRAL"
                            href="${this
                              .baseUrl}/connexion-internet/internet-radio"
                          >
                            Internet Radio MISTRAL
                          </a>
                        </li>
                      </ul>
                      <a
                        id="footer-mobile-gamme"
                        class="footer-middle--subtitle subtitle-02"
                        title="Découvrez notre gamme Mobile"
                        href="${this.baseUrl}/forfaits-mobile"
                      >
                        Mobile
                      </a>
                      <ul class="footer-middle--category">
                        <li class="footer-middle--category_item">
                          <a
                            id="footer-forfaits-mobile-link"
                            class="link"
                            title="Forfaits Mobile"
                            href="${this.baseUrl}/forfaits-mobile"
                          >
                            Forfaits Mobile
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div class="custom-flex--column">
                      <div class="links-title">
                        <a
                          class="footer-middle--subtitle subtitle-02"
                          id="footer-VPN"
                          title="Découvrez nos solutions de sécurité Internet"
                          href="${this.baseUrl}/securite"
                        >
                          Antivirus & VPN
                        </a>
                      </div>
                      <ul class="footer-middle--category with-margin">
                        <li class="footer-middle--category_item">
                          <a
                            class="paragraph-02"
                            title="Securitoo Intégral"
                            id="footer-secInt"
                            href="${this.baseUrl}/securite/securitoo-antivirus"
                          >
                            Securitoo Antivirus
                          </a>
                        </li>
                        <li class="footer-middle--category_item">
                          <a
                            class="paragraph-02"
                            title="Securitoo Freedome"
                            id="footer-secFree"
                            href="${this.baseUrl}/securite/securitoo-freedome"
                          >
                            Securitoo Freedome
                          </a>
                        </li>
                      </ul>
                      <div class="links-title">
                        <a
                          class="footer-middle--subtitle subtitle-02"
                          id="footer-domaine"
                          title="Réservez votre nom de domaine chez Nordnet"
                          href="${this.baseUrl}/nom-de-domaine"
                        >
                          Noms de domaine
                        </a>
                      </div>
                      <ul class="footer-middle--category">
                        <li class="footer-middle--category_item">
                          <a
                            class="paragraph-02"
                            id="footer-relais"
                            title="Pack Relais Domaine"
                            href="${this.baseUrl}/nom-de-domaine"
                          >
                            Pack Relais Domaine
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="custom-flex--column with-decoration">
                <input
                  class="single-toggle-input"
                  type="checkbox"
                  name="singletab"
                  id="footer-tab-2"
                />
                <label
                  class="single-toggle-label subtitle-02"
                  for="footer-tab-2"
                  >Nordnet et vous</label
                >
                <div class="single-toggle-content">
                  <ul class="footer-middle--category">
                    <li class="footer-middle--category_item">
                      <a
                        class="paragraph-02"
                        title="Blog"
                        id="footer-blog"
                        href="https://blog.nordnet.com"
                        target="_blank"
                        rel="noopener"
                      >
                        Blog
                      </a>
                    </li>
                    <li class="footer-middle--category_item">
                      <a
                        class="paragraph-02"
                        title="Qui sommes-nous ?"
                        id="footer-who"
                        href="${this.baseUrl}/qui-sommes-nous"
                      >
                        Qui sommes-nous&nbsp;?
                      </a>
                    </li>
                    <li class="footer-middle--category_item">
                      <a
                        class="paragraph-02"
                        title="Recrutement"
                        id="footer-recrutement"
                        href="${this.baseUrl}/recrutement"
                      >
                        Recrutement
                      </a>
                    </li>
                    <li class="footer-middle--category_item">
                      <a
                        class="paragraph-02"
                        id="footer-partenaire"
                        rel="noopener"
                        title="Devenir partenaire"
                        target="_blank"
                        href="https://partenaires.nordnet.com"
                      >
                        Devenir partenaire
                      </a>
                    </li>
                    <li class="footer-middle--category_item">
                      <a
                        class="paragraph-02"
                        title="Espace Presse"
                        id="footer-presse"
                        href="${this.baseUrl}/espace-presse"
                      >
                        Espace Presse
                      </a>
                    </li>
                    <li class="footer-middle--category_item">
                      <a
                        class="paragraph-02"
                        title="Guides"
                        id="footer-guides"
                        href="${this.baseUrl}/guides"
                      >
                        Guides
                      </a>
                    </li>
                    <li class="footer-middle--category_item">
                      <a
                        class="paragraph-02"
                        title="Lancer une alerte"
                        id="footer-alerte"
                        href="https://orange.integrityline.org"
                        target="_blank"
                        rel="noopener nofollow"
                      >
                        Lancer une alerte
                      </a>
                    </li>
                    <li class="footer-middle--category_item">
                      <a
                        class="paragraph-02 anchor"
                        id="footer-carte"
                        title="Carte de couverture technologies haut débit"
                        href="${this.baseUrl}/carte-technologies-haut-debit"
                      >
                        Carte de couverture haut&nbsp;débit
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="custom-flex--column">
                <input
                  class="single-toggle-input"
                  type="checkbox"
                  name="singletab"
                  id="footer-tab-3"
                />
                <label
                  class="single-toggle-label subtitle-02"
                  for="footer-tab-3"
                  >Documents pratiques</label
                >
                <div class="single-toggle-content">
                  <ul class="footer-middle--category">
                    <li class="footer-middle--category_item">
                      <a
                        class="paragraph-02"
                        title="Conditions et récapitulatifs contractuels"
                        id="footer-documentation-contractuelle"
                        href="${this.baseUrl}/documentation-contractuelle"
                      >
                        Conditions et récapitulatifs contractuels
                      </a>
                    </li>
                    <li class="footer-middle--category_item">
                      <a
                        class="paragraph-02 "
                        title="Découvrez les fichiers produits des solutions Nordnet"
                        id="footer-produits"
                        href="${this.baseUrl}/documentation"
                      >
                        Documentation produits
                      </a>
                    </li>
                    <li class="footer-middle--category_item">
                      <a
                        class="paragraph-02"
                        id="footer-retractation"
                        rel="nofollow"
                        title="Formulaire de rétractation"
                        target="_blank"
                        href="${this.baseUrl}/pdf/formulaire-retractation.pdf"
                      >
                        Formulaire de rétractation
                      </a>
                    </li>
                    <li class="footer-middle--category_item">
                      <a
                        class="paragraph-02"
                        id="footer-parrainage"
                        rel="noopener nofollow"
                        title="Règlement Parrainage"
                        target="_blank"
                        href="${this.baseUrl}/pdf/reglement-parrainage.pdf"
                      >
                        Règlement Parrainage
                      </a>
                    </li>
                    <li class="footer-middle--category_item mobile-visible">
                      <a
                        class="paragraph-02"
                        id="footer-tarifs"
                        title="Nos tarifs"
                        href="${this.baseUrl}/tarifs"
                      >
                        Nos tarifs
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-bottom">
          <div class="container">
            <div class="custom-flex footer-bottom--logos">
              <img
                src="${assetsPath}/images/logos/logo-nordnet-white.svg"
                alt="Nordnet"
                width="155"
                height="28"
              />

              <img
                src="${assetsPath}/images/logos/logo-orange-with-baseline.png"
                alt="Orange"
                width="134"
                height="36"
              />
            </div>
            <div class="custom-flex footer-bottom--links">
              <ul class="footer-bottom--listing">
                <li class="footer-bottom--listing_item">
                  <a
                    class="paragraph-03"
                    title="Données personnelles et cookies"
                    id="footer-personnelles"
                    href="${this
                      .baseUrl}/donnees-personnelles-politique-cookies"
                  >
                    Données personnelles & cookies
                  </a>
                </li>
                <li class="footer-bottom--listing_item">
                  <a
                    class="paragraph-03"
                    title="Gérer les Cookies"
                    id="footer-Cookies"
                    href="${this.didomiUrl}"
                  >
                    Gérer les cookies
                  </a>
                </li>
                <li class="footer-bottom--listing_item">
                  <a
                    class="paragraph-03"
                    title="Informations légales"
                    id="footer-Informations"
                    href="${this.baseUrl}/informations-legales"
                  >
                    Informations légales
                  </a>
                </li>
                <li class="footer-bottom--listing_item">
                  <a
                    class="paragraph-03"
                    title="Médiateur des communications électroniques"
                    id="footer-mediateur-communications-electroniques"
                    href="${this
                      .baseUrl}/mediateur-communications-electroniques"
                  >
                    Médiateur des communications électroniques
                  </a>
                </li>
                <li class="footer-bottom--listing_item">
                  <a
                    class="paragraph-03"
                    title="Notification de contenus illicites et protection de l'enfance"
                    id="footer-illicites"
                    href="${this.baseUrl}/contenus-illicites-protection-enfance"
                  >
                    Notification de contenus illicites & protection de l'enfance
                  </a>
                </li>
                <li class="footer-bottom--listing_item">
                  <a
                    class="paragraph-03"
                    title="Plan du site"
                    id="footer-site"
                    href="${this.baseUrl}/plan-du-site"
                  >
                    Plan du site
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    `;
  }
}
